import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './EmployeePayrollReport.css';
import { useNavigate } from 'react-router-dom';
import ExcelJS from "exceljs";
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { fetchMonths, getDistrict, getProjects, getStates } from '../../../services/monthlyAttendanceService';
import { getSalaryStructureReport } from '../../../services/payrollService';
import Month from 'react-calendar/dist/cjs/YearView/Month.js';
import { capitalizeFirstLetter } from '../../../utils/validations';

const EmployeePayrollReport = () => {
    const navigate = useNavigate();
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
        project: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false);
    const yearInputRef = useRef(null);
    const isFetchDataEnabled = state && month && year;
    // const selectStyles = {
    //     menuPortal: base => ({ ...base, zIndex: 9999 }),
    //     menu: base => ({ ...base, marginTop: '5px', zIndex: 9999 }),
    //     control: provided => ({ ...provided, padding: '1px' }),
    //     valueContainer: provided => ({ ...provided, padding: '3px 6px' }),
    // };
    const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);
    const [projectResponse, setProjectResponse] = useState([]);
    const [project, setProject] = useState(null);
    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/states/nationality/1`);
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label:  capitalizeFirstLetter(item.stateName),
                        name: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        fetchStates();
    }, []);

    // Fetch months
    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonths(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);

    // useEffect(() => {
    //     const fetchMonths = async () => {
    //         try {
    //             const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/months`);
    //             const now = new Date();
    //             const currentYear = now.getFullYear();
    //             const currentMonth = now.getMonth() + 1;
    //             const currentDate = now.getDate();
    //             const lastDayOfCurrentMonth = new Date(currentYear, currentMonth, 0).getDate();

    //             const months = response.data
    //                 .map(item => {
    //                     let daysInMonth;
    //                     if (year === currentYear && item.monthId === currentMonth) {
    //                         daysInMonth = currentDate;
    //                     } else {
    //                         daysInMonth = new Date(year, item.monthId, 0).getDate();
    //                     }
    //                     return {
    //                         value: item.monthId,
    //                         label: item.monthName,
    //                         days: daysInMonth,
    //                     };
    //                 })
    //                 .sort((a, b) => a.value - b.value);

    //             let filteredMonths = months;
    //             if (year) {
    //                 if (year === currentYear) {
    //                     filteredMonths = months.filter(m => {
    //                         if (m.value < currentMonth) return true;
    //                         if (m.value === currentMonth) {
    //                             return currentDate === lastDayOfCurrentMonth;
    //                         }
    //                         return false;
    //                     });
    //                 } else if (year > currentYear) {
    //                     filteredMonths = [];
    //                 } else {
    //                     filteredMonths = months;
    //                 }
    //             }
    //             setMonthOptions(filteredMonths);
    //         } catch (error) {
    //             console.error('Error fetching months:', error);
    //             setErrors(prev => ({ ...prev, general: 'Failed to load months' }));
    //         }
    //     };
    //     fetchMonths();
    // }, [year]);

    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/districts/state/${state}`);
                    const data = await getDistrict(state)
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
            setMonth(null);
            setAttendanceData([]);
            setHasFetched(false);
        }
    }, [state]);
    useEffect(() => {
        const fetchProjects = async () => {
            try {
                // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/projects`);
                const data = await getProjects();
                setProjectResponse(data.map(pro => ({
                    value: pro.id,
                    label: pro.projectCode,
                }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        fetchProjects();
    }, []);
    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setAttendanceData([]);
                setHasFetched(false);
                setProject(null);
                break;
            case 'district':
                setDistrict(value);
                setMonth(null);
                setAttendanceData([]);
                setHasFetched(false);
                setProject(null);
                break;
            case 'month':
                setMonth(value);
                setAttendanceData([]);
                setHasFetched(false);
                setProject(null);
                break;
            case 'project':
                setProject(value); // ✅ Handle project selection
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        const newYear = date ? date.getFullYear() : null;
        setYear(newYear);
        setMonth(null);
        setAttendanceData([]);
        setHasFetched(false);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        // if (!district) newErrors.district = 'District is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(prev => ({ ...prev, ...newErrors }));
        return Object.keys(newErrors).length === 0;
    };

    const handleFetch = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            // build params dynamically
            const params = {
                stateId: state,   // required
                month,
                year,
            };

            if (district) {
                params.districtId = district; // only include if provided
            }
            if (project) {
                params.projectId = project; // only include if provided
            }

            //  const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/salary-structure/report`,{ params });
            const response = await getSalaryStructureReport(params);
            const data = Array.isArray(response.data) ? response.data : [response.data];

            console.log("API response:", data);

            setAttendanceData(data);
            setOriginalData(data);
            setHasFetched(true);
            setErrors((prev) => ({ ...prev, general: null }));
        } catch (error) {
            console.error("Error fetching payroll data:", error);
            setErrors((prev) => ({
                ...prev,
                general: error.response?.data?.message || "Failed to fetch payroll data",
            }));
            setAttendanceData([]);
            setHasFetched(false);
        }
    };



    // Download Excel
    //     const handleFetch = async (e) => {
    //     e.preventDefault();
    //     if (!validateForm()) return;

    //     try {
    //         // Build params without district
    //         const params = {
    //             state: stateOptions.find(opt => opt.value === state)?.label, // Use state label (e.g., "Bihar")
    //             month,
    //             year,
    //         };
    //        if (district ) {
    //     params.district = districtOptions.find(opt => opt.value === district)?.label; // Send district name instead of ID if needed
    // }
    //         const response = await axios.get(
    //             `${process.env.REACT_APP_API_BASE_URL}/api/salary-structure/calculate`,
    //             { params }
    //         );

    //         const data = Array.isArray(response.data) ? response.data : [response.data];

    //         console.log("API response:", data);

    //         setAttendanceData(data);
    //         setOriginalData(data);
    //         setHasFetched(true);
    //         setErrors((prev) => ({ ...prev, general: null }));
    //     } catch (error) {
    //         console.error("Error fetching payroll data:", error);
    //         setErrors((prev) => ({
    //             ...prev,
    //             general: error.response?.data?.message || "Failed to fetch payroll data",
    //         }));
    //         setAttendanceData([]);
    //         setHasFetched(false);
    //     }
    // };
    const downloadExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Payroll Report");
        // Title
        worksheet.mergeCells("A1:AH1");
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "Employee Payroll Report";
        titleCell.font = { size: 16, bold: true };
        titleCell.alignment = { vertical: "middle", horizontal: "center" };
        // --- First Header Row (Grouped Headers) ---
        worksheet.mergeCells("A2:H2"); // empty cells
        worksheet.mergeCells("J2:N2"); worksheet.getCell("J2").value = "GROSS SALARY";
        worksheet.mergeCells("O2:P2"); worksheet.getCell("O2").value = "ATTENDANCE";
        worksheet.mergeCells("Q2:U2"); worksheet.getCell("Q2").value = "EARNINGS";
        worksheet.mergeCells("V2:X2"); worksheet.getCell("V2").value = "DEDUCTIONS";
        worksheet.getCell("Y2").value = "Net Salary";
        worksheet.mergeCells("Z2:AA2"); worksheet.getCell("Z2").value = "EMPLOYER CONT";
        worksheet.mergeCells("AB2:AC2"); // empty
        worksheet.mergeCells("AD2:AF2"); // empty
        worksheet.mergeCells("AG2:AH2"); // empty

        // Style first header row
        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { vertical: "middle", horizontal: "center" };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });

        // Background colors for grouped headers
        worksheet.getCell("J2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "A3E8FB" } };
        worksheet.getCell("O2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "A1F696" } };
        worksheet.getCell("Q2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "EF89F8" } };
        worksheet.getCell("V2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "F6EC96" } };
        worksheet.getCell("X2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "A1F696" } };
        worksheet.getCell("Y2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "EF89F8" } };
        worksheet.getCell("Z2").fill = { type: "pattern", pattern: "solid", fgColor: { argb: "A1F696" } };
        // --- Second Header Row (Actual Columns) ---
        const header = [
            "S.No.", "Employee ID", "Name of the Employee", "District Name", "Designation",
            "UAN", "Member ID", "ESIC No.", "Name",
            "Basic & DA", "HRA", "Conveyance", "Other Allowances", "Total Gross Salary",
            "No of Days", "Present Days",
            "Basic", "HRA", "Conveyance", "Other Allowances", "Total Gross Salary",
            "PT", "PF Employee", "ESI Employee",
            "Net Salary",
            "Employer PF", "Employer ESI",
            "SBI Account Number", "IFSC Code", "SBI Branch",
            "CTC", "Total PF", "Total ESI", "EPF Wages", "ESI Wages"
        ];
        worksheet.addRow(header);

        worksheet.getRow(3).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "004080" }, // dark blue
            };
            cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
        });

        // --- Data Rows ---
        attendanceData.forEach((row, index) => {
            const rowValues = [
                index + 1,
                row.employeeId,
                row.fullName,
                row.districtName,
                row.designation,
                row.uanNumber,
                row.memberId,
                row.esiNumber,
                row.fullName,
                row.defaultBasicSalary,
                row.defaultHra,
                row.defaultConveyance,
                row.defaultMedicalAllowance + row.defaultOtherAllowance,
                row.defaultGrossSalary,
                row.totalDaysInMonth,
                row.presentDays,
                row.calculatedBasicSalary,
                row.calculatedHra,
                row.calculatedConveyance,
                row.calculatedMedicalAllowance + row.calculatedOtherAllowance,
                row.calculatedGrossSalary,
                row.calculatedPt,
                row.calculatedEpf,
                row.calculatedEsi,
                row.calculatedNetSalary,
                row.calculatedEmployerEpf,
                row.calculatedEmployerEsi,
                row.accountNumber || "-",
                row.ifscCode || "-",
                row.branchName || "-",
                row.calculatedCtcAsPerBreakup,
                (row.calculatedEpf) + (row.calculatedEmployerEpf),
                (row.calculatedEsi) + (row.calculatedEmployerEsi),
                row.epfWages,
                row.esiWages,
            ];

            const addedRow = worksheet.addRow(rowValues);

            addedRow.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };
                cell.alignment = { vertical: "middle", horizontal: "center" };
            });
            if (index % 2 === 0) {
                addedRow.eachCell((cell) => {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "F2F2F2" },
                    };
                });
            }
        });

        // Adjust column widths
        worksheet.columns.forEach((col) => {
            col.width = 18;
        });

        // Download Excel
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
         const monthName = monthOptions.find((m) => m.value === month)?.label || "Unknown";

        const a = document.createElement("a");
        a.href = url;
        a.download = `Payroll_Report_${monthName}_${year}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
    };
    // const downloadExcel = async () => {
    //     const workbook = new ExcelJS.Workbook();
    //     const worksheet = workbook.addWorksheet("Payroll Report");

    //     // --- Title ---
    //     worksheet.mergeCells("A1:AH1");
    //     const titleCell = worksheet.getCell("A1");
    //     titleCell.value = "Employee Payroll Report";
    //     titleCell.font = { size: 16, bold: true };
    //     titleCell.alignment = { vertical: "middle", horizontal: "center" };

    //     // --- Filters Row (State, District, Year, Month, Project) ---
    //     const downloadDate = new Date().toLocaleDateString();
    //     const filters = [
    //         ["State", state || "-"],
    //         ["District", district || "-"],
    //         ["Year", year || "-"],
    //         ["Month", month || "-"],
    //         ["Project", project || "-"],
    //         ["Download Date", downloadDate]
    //     ];

    //     let rowIndex = 2;
    //     filters.forEach(([label, value]) => {
    //         worksheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
    //         worksheet.getCell(`A${rowIndex}`).value = label;
    //         worksheet.getCell(`A${rowIndex}`).font = { bold: true };

    //         worksheet.mergeCells(`C${rowIndex}:H${rowIndex}`);
    //         worksheet.getCell(`C${rowIndex}`).value = value;
    //         worksheet.getCell(`C${rowIndex}`).alignment = { vertical: "middle", horizontal: "left" };

    //         rowIndex++;
    //     });

    //     // --- First Header Row (Grouped Headers) ---
    //     worksheet.mergeCells(`A${rowIndex}:H${rowIndex}`); // empty cells
    //     worksheet.mergeCells(`I${rowIndex}:M${rowIndex}`); worksheet.getCell(`I${rowIndex}`).value = "GROSS SALARY";
    //     worksheet.mergeCells(`N${rowIndex}:O${rowIndex}`); worksheet.getCell(`N${rowIndex}`).value = "ATTENDANCE";
    //     worksheet.mergeCells(`P${rowIndex}:T${rowIndex}`); worksheet.getCell(`P${rowIndex}`).value = "EARNINGS";
    //     worksheet.mergeCells(`U${rowIndex}:W${rowIndex}`); worksheet.getCell(`U${rowIndex}`).value = "DEDUCTIONS";
    //     worksheet.getCell(`X${rowIndex}`).value = "Net Salary";
    //     worksheet.mergeCells(`Y${rowIndex}:Z${rowIndex}`); worksheet.getCell(`Y${rowIndex}`).value = "EMPLOYER CONT";
    //     worksheet.mergeCells(`AA${rowIndex}:AC${rowIndex}`); // empty
    //     worksheet.mergeCells(`AD${rowIndex}:AF${rowIndex}`); // empty
    //     worksheet.mergeCells(`AG${rowIndex}:AH${rowIndex}`); // empty

    //     // Style first header row
    //     worksheet.getRow(rowIndex).eachCell((cell) => {
    //         cell.font = { bold: true };
    //         cell.alignment = { vertical: "middle", horizontal: "center" };
    //         cell.border = {
    //             top: { style: "thin" },
    //             left: { style: "thin" },
    //             bottom: { style: "thin" },
    //             right: { style: "thin" },
    //         };
    //     });

    //     // Add second header row (columns)
    //     rowIndex++;
    //     const header = [
    //         "S.No.", "Name of the Employee", "Employee ID", "District Name", "Designation",
    //         "PF UAN Member ID", "Insurance No.", "Name",
    //         "Basic & DA", "HRA", "Conveyance", "Other Allowances", "Total Gross Salary",
    //         "No of Days", "Present Days",
    //         "Basic", "HRA", "Conveyance", "Other Allowances", "Total Gross Salary",
    //         "PT", "PF Employee", "ESI Employee",
    //         "Net Salary",
    //         "Employer PF", "Employer ESI",
    //         "SBI Account Number", "IFSC Code", "SBI Branch",
    //         "CTC", "Total PF", "Total ESI", "EPF Wages", "ESI Wages"
    //     ];
    //     worksheet.addRow(header);

    //     // Style second header row
    //     worksheet.getRow(rowIndex).eachCell((cell) => {
    //         cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    //         cell.fill = {
    //             type: "pattern",
    //             pattern: "solid",
    //             fgColor: { argb: "004080" }, // dark blue
    //         };
    //         cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    //         cell.border = {
    //             top: { style: "thin" },
    //             left: { style: "thin" },
    //             bottom: { style: "thin" },
    //             right: { style: "thin" },
    //         };
    //     });

    //     // --- Data Rows ---
    //     attendanceData.forEach((row, index) => {
    //         const rowValues = [
    //             index + 1,
    //             row.fullName,
    //             row.employeeId,
    //             row.districtName,
    //             row.designation,
    //             row.uanNumber,
    //             row.esiNumber,
    //             row.fullName,
    //             row.calculatedBasicSalary,
    //             row.calculatedHra,
    //             row.calculatedConveyance,
    //             row.calculatedMedicalAllowance + row.calculatedSpecialAllowance,
    //             row.calculatedGrossSalary,
    //             row.totalDaysInMonth,
    //             row.presentDays,
    //             row.calculatedBasicSalary,
    //             row.calculatedHra,
    //             row.calculatedConveyance,
    //             row.calculatedMedicalAllowance + row.calculatedSpecialAllowance,
    //             row.calculatedGrossSalary,
    //             row.calculatedPt,
    //             row.calculatedEpf,
    //             row.calculatedEsi,
    //             row.calculatedNetSalary,
    //             row.calculatedEmployerEpf,
    //             row.calculatedEmployerEsi,
    //             row.accountNumber || "-",
    //             row.ifscCode || "-",
    //             row.branchName || "-",
    //             row.calculatedCtcAsPerBreakup,
    //             row.calculatedEpf,
    //             row.calculatedEsi,
    //             row.calculatedEpf,
    //             row.calculatedEsi,
    //         ];

    //         const addedRow = worksheet.addRow(rowValues);

    //         addedRow.eachCell((cell) => {
    //             cell.border = {
    //                 top: { style: "thin" },
    //                 left: { style: "thin" },
    //                 bottom: { style: "thin" },
    //                 right: { style: "thin" },
    //             };
    //             cell.alignment = { vertical: "middle", horizontal: "center" };
    //         });

    //         if (index % 2 === 0) {
    //             addedRow.eachCell((cell) => {
    //                 cell.fill = {
    //                     type: "pattern",
    //                     pattern: "solid",
    //                     fgColor: { argb: "F2F2F2" },
    //                 };
    //             });
    //         }
    //     });

    //     // Adjust column widths
    //     worksheet.columns.forEach((col) => {
    //         col.width = 18;
    //     });

    //     // Download Excel
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const blob = new Blob([buffer], {
    //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });
    //     const url = window.URL.createObjectURL(blob);
    //     const a = document.createElement("a");
    //     a.href = url;
    //     a.download = "Payroll_Report.xlsx";
    //     a.click();
    //     window.URL.revokeObjectURL(url);
    // };



    return (
        <>
            <div className="payroll-container">
                <div className="payroll-box">
                    <h2 className="payroll-heading">Employee Payroll Report</h2>
                    {errors.general && <div className="error-message">{errors.general}</div>}
                    <form onSubmit={handleFetch}>
                        <div className="payroll-maincontainer">
                            <div className="payroll-container-part">
                                <div className={`payroll-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                    <Select
                                        name="state"
                                        options={stateOptions}
                                        value={stateOptions.find(opt => opt.value === state) || null}
                                        onChange={option => handleInputChange(option, 'state')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        <span className="required">*</span>State
                                    </label>
                                    {errors.state && <div className="error-message">{errors.state}</div>}
                                </div>
                            </div>
                            <div className="payroll-container-part">
                                {/* <div className={`payroll-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                    <Select
                                        name="district"
                                        options={districtOptions}
                                        value={districtOptions.find(opt => opt.value === district) || null}
                                        onChange={option => handleInputChange(option, 'district')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                      District
                                    </label>
                                    {errors.district && <div className="error-message">{errors.district}</div>}
                                </div> */}
                            </div>
                        </div>
                        <div className="payroll-maincontainer">
                            <div className="payroll-container-part">
                                <div className={`payroll-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                    <DatePicker
                                        selected={year ? new Date(year, 0, 1) : null}
                                        onChange={handleYearChange}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                        dateFormat="yyyy"
                                        showYearPicker
                                        placeholderText=""
                                        className="payroll-date-picker"
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        ref={yearInputRef}
                                    />
                                    <label>
                                        <span className="required">*</span>Year
                                    </label>
                                    {errors.year && <div className="error-message">{errors.year}</div>}
                                </div>
                            </div>
                            <div className="payroll-container-part">
                                <div className={`payroll-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                    <Select
                                        name="month"
                                        options={monthOptions}
                                        value={monthOptions.find(opt => opt.value === month) || null}
                                        onChange={option => handleInputChange(option, 'month')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        <span className="required">*</span>Month
                                    </label>
                                    {errors.month && <div className="error-message">{errors.month}</div>}
                                </div>
                            </div>
                        </div>
                        {/* <div className="payroll-maincontainer">

                            <div className="payroll-container-part">
                                <div className={`payroll-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}>
                                    <Select
                                        name="project"
                                        options={projectResponse}
                                        value={projectResponse.find(opt => opt.value === project) || null}
                                        onChange={option => handleInputChange(option, 'project')}
                                        onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                        onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                        placeholder=" "
                                        isClearable
                                        menuPortalTarget={document.body}
                                        styles={selectStyles}
                                    />
                                    <label>
                                        Project
                                    </label>
                                    {errors.project && <div className="error-message">{errors.project}</div>}
                                </div>
                            </div>
                            <div className="payroll-container-part">

                            </div>
                        </div> */}
                        <div className="payroll-btn-div">
                            <button
                                type="submit"
                                className="payroll-btn"
                                disabled={!isFetchDataEnabled}
                            >
                                Fetch Data
                            </button>
                        </div>
                    </form>


                </div>

            </div>
            <div className="payroll-table-container">
                <h3>Payroll Data</h3>
                <button
                    className="download-excel-btn"
                    onClick={downloadExcel}
                >
                    Download Excel
                </button>
                <table className="payroll-table">
                    <thead >
                        <tr className='span-headers'>
                            <th colSpan="9"></th>
                            <th colSpan="5" style={{ backgroundColor: "rgb(163 232 251)" }}>GROSS SALARY</th>
                            <th colSpan="2" style={{ backgroundColor: "#a1f696" }}>ATTENDANCE</th>
                            <th colSpan="5" style={{ backgroundColor: "#ef89f8ff" }}>EARNINGS</th>
                            <th colSpan="3" style={{ backgroundColor: "#f6ec96ff" }}>DEDUCTIONS</th>
                            <th style={{ backgroundColor: "#a1f696", whiteSpace: "nowrap" }}>Net Salary</th>
                            <th colSpan="2" style={{ backgroundColor: "#ef89f8ff" }}>EMPLOYER CONT</th>
                            <th colSpan="3"></th>
                            <th colSpan="3"></th>
                            <th colSpan="2"></th>
                        </tr>
                        <tr>

                            <th>S.No.</th>
                            <th>Employee ID</th>
                            <th>Name of the Employee</th>
                            <th>District Name</th>
                            <th>Designation</th>
                            <th>UAN</th>
                            <th>Member ID</th>
                            <th>ESIC No.</th>
                            <th>Name</th>
                            <th>Basic & DA</th>
                            <th>HRA</th>
                            <th>Conveyance</th>
                            <th>Other Allowances</th>
                            <th>Total Gross Salary</th>
                            <th>No of Days </th>
                            <th>Present Days</th>
                            <th>Basic</th>
                            <th>HRA</th>
                            <th>Conveyance</th>
                            <th>Other Allowances</th>
                            <th>Total Gross Salary</th>
                            <th>PT</th>
                            <th>PF Employee</th>
                            <th>ESI Employee</th>
                            <th>Net Salary</th>
                            <th>Employer PF</th>
                            <th>Employer ESI</th>
                            <th>SBI Account Number</th>
                            <th>IFSC Code</th>
                            <th>SBI Branch</th>
                            <th>CTC</th>
                            <th>Total PF</th>
                            <th>Total ESI</th>
                            <th>EPF Wages</th>
                            <th>ESI Wages</th>
                        </tr>
                    </thead>

                    <tbody >
                        {attendanceData.map((emp, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{emp.employeeId}</td>
                                <td>{emp.fullName}</td> {/* fullName instead of employeeName */}
                                <td>{emp.districtName}</td>
                                <td>{emp.designation}</td>
                                <td>{emp.uanNumber}</td> {/* PF UAN Member ID */}
                                <td>{emp.memberId}</td>
                                <td>{emp.esiNumber}</td> {/* Insurance No. */}
                                <td>{emp.fullName}</td> {/* Name */}
                                <td>{emp.defaultBasicSalary}</td> {/* Basic & DA */}
                                <td>{emp.defaultHra}</td>
                                <td>{emp.defaultConveyance}</td>
                                <td>{emp.defaultMedicalAllowance + emp.defaultOtherAllowance}</td> {/* Other Allowances */}
                                <td>{emp.defaultGrossSalary}</td> {/* Total Gross Salary */}
                                <td>{emp.totalDaysInMonth}</td> {/* No of Days */}
                                <td>{emp.presentDays}</td>
                                <td>{emp.calculatedBasicSalary}</td>
                                <td>{emp.calculatedHra}</td>
                                <td>{emp.calculatedConveyance}</td>
                                <td>{emp.calculatedMedicalAllowance + emp.calculatedOtherAllowance}</td>
                                <td>{emp.calculatedGrossSalary}</td>
                                <td>{emp.calculatedPt}</td>
                                <td>{emp.calculatedEpf}</td>
                                <td>{emp.calculatedEsi}</td>
                                <td>{emp.calculatedNetSalary}</td>
                                <td>{emp.calculatedEmployerEpf}</td>
                                <td>{emp.calculatedEmployerEsi}</td>
                                <td>{emp.accountNumber || "-"}</td>
                                <td>{emp.ifscCode || "-"}</td>
                                <td>{emp.branchName || "-"}</td>
                                <td>{emp.calculatedCtcAsPerBreakup}</td>
                                <td>{(emp.calculatedEpf) + (emp.calculatedEmployerEpf)}</td> {/* Total PF */}
                                <td>{(emp.calculatedEsi) + (emp.calculatedEmployerEsi)}</td> {/* Total ESI */}
                                <td>{emp.epfWages}</td> {/* EPF Wages */}
                                <td>{emp.esiWages}</td> {/* ESI Wages */}
                            </tr>
                        ))}
                    </tbody>



                </table>
            </div>

            {hasFetched && attendanceData.length === 0 && (
                <div className="no-data-message">
                    No payroll data found for the selected criteria.
                </div>
            )}
        </>
    );
};

export default EmployeePayrollReport;